import { EditorEvent } from '../editor/types';

export abstract class PendingEvent extends EditorEvent {
  protected constructor(type: string) {
    super('Pending', type);
  }
}

export class PendingStart extends PendingEvent {
  constructor() {
    super('start');
  }
}

export class PendingEnd extends PendingEvent {
  constructor() {
    super('end');
  }
}

export type PendingEvents = PendingStart | PendingEnd;
